/**
 * Shared query keys for TanStack Query
 */
export const QUERY_KEYS = {
  PROJECTS: "projects",
  MCP_SERVERS: "MCP_SERVERS",
  SECRETS: "SECRETS",
  ENDPOINTS: "endpoints",
  TASKS: "TASKS",
  DEPLOYMENTS: "DEPLOYMENTS",
  FILESYSTEM: "FILESYSTEM",
  TRACES: "TRACES",
} as const;
